"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTypedPlatformFunctionResponse = exports.useTypedPlatformFunction = void 0;
var useTypedPlatformFunction_1 = require("./hooks/useTypedPlatformFunction");
Object.defineProperty(exports, "useTypedPlatformFunction", { enumerable: true, get: function () { return useTypedPlatformFunction_1.useTypedPlatformFunction; } });
var useTypedPlatformFunctionResponse_1 = require("./hooks/useTypedPlatformFunctionResponse");
Object.defineProperty(exports, "useTypedPlatformFunctionResponse", { enumerable: true, get: function () { return useTypedPlatformFunctionResponse_1.useTypedPlatformFunctionResponse; } });
